import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    toolbarButtons: {
      height: 50,
      width: 50,
      marginLeft: theme.spacing(0),
      borderRadius: "5em",
      backgroundColor: theme.palette.error.main,
      color: theme.palette.primary.contrastText,
      "&:hover": {
        backgroundColor: theme.palette.error.dark,
      },
    },
  })
);
